import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSocialProfile } from "src/hooks";
import usePermissions from "src/hooks/usePermissions/usePermissions";
import type { Permission } from "src/constants/permissions";

interface GuardRouteProps {
	requiredPermission?: Permission | string;
	restrictedToEstateManager?: boolean;
}

const GuardRoute = ({
	requiredPermission,
	restrictedToEstateManager
}: GuardRouteProps) => {
	const { data: profile } = useSocialProfile();
	const { hasPermission, isLoading } = usePermissions();
	const location = useLocation();

	if (isLoading) return null;

	if (requiredPermission) {
		return hasPermission(requiredPermission) ? (
			<Outlet />
		) : (
			<Navigate to="/access-denied" replace state={{ from: location }} />
		);
	}

	if (restrictedToEstateManager) {
		if (
			profile?.retail_user?.manager_of_area ||
			profile?.retail_user?.manager_of_region ||
			profile?.retail_user?.manager_of_store ||
			hasPermission("CanViewObservationReporting")
		) {
			return <Outlet />;
		} else {
			return (
				<Navigate to="/access-denied" replace state={{ from: location }} />
			);
		}
	}

	return <Outlet />;
};

export default GuardRoute;
